import {
  PlanningFreightAppointment,
  PlanningFreightProbill,
} from "app/data/linehaul-outbound-planning/models";

function hasNestedAppointmentDetails(
  appt: PlanningFreightAppointment | null | undefined
): boolean {
  if (!appt) return false;
  return Boolean(appt.date || appt.confirmedDateTime || appt.earlyTime || appt.lateTime);
}

function buildAppointmentFromFlatFields(
  row: PlanningFreightProbill
): PlanningFreightAppointment | null {
  const date = row.appointmentDate ?? null;
  const earlyTime = row.appointmentEarlyTime ?? null;
  const lateTime = row.appointmentLateTime ?? null;
  const confirmedDateTime = row.appointmentConfirmedDateTime ?? null;
  if (!date && !earlyTime && !lateTime && !confirmedDateTime) return null;
  return { date, earlyTime, lateTime, confirmedDateTime };
}

/**
 * Nest/Spring return flat appointment fields.
 * Builds nested `appointment` from flat fields for hover / Appt Date only.
 * Icon color is driven by hasAppointment / appointmentStatus / appointmentRequired
 * in the column helpers — not by whether date fields exist.
 */
export function normalizeAppointmentOnFreight(
  row: PlanningFreightProbill
): PlanningFreightProbill {
  const status = String(row.appointmentStatus ?? "").toUpperCase();
  const appointment =
    (hasNestedAppointmentDetails(row.appointment) ? row.appointment : null) ??
    buildAppointmentFromFlatFields(row) ??
    row.appointment ??
    null;

  // Keep boolean in sync with status for consumers; icon still checks status directly.
  const appointmentRequired =
    row.appointmentRequired === true || status === "NEEDED";

  return {
    ...row,
    appointment,
    appointmentRequired,
  };
}

export function normalizeAppointmentsOnFreightList(
  rows: PlanningFreightProbill[]
): PlanningFreightProbill[] {
  return rows.map(normalizeAppointmentOnFreight);
}
